"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrendingSearchPill = exports.ChannelPill = void 0;
var js_brand_1 = require("@giphy/js-brand");
var react_1 = __importStar(require("react"));
var avatar_1 = __importDefault(require("../../attribution/avatar"));
var verified_badge_1 = __importDefault(require("../../attribution/verified-badge"));
var context_1 = require("../context");
var theme_1 = __importStar(require("../theme"));
var trending_icon_1 = __importDefault(require("./trending-icon"));
var margin = 9;
var ChannelPillContainer = theme_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n    padding-right: 4px;\n    align-items: center;\n    margin-right: ", "px;\n    cursor: pointer;\n"], ["\n    background: ", ";\n    display: flex;\n    padding-right: 4px;\n    align-items: center;\n    margin-right: ", "px;\n    cursor: pointer;\n"])), js_brand_1.giphyDarkestGrey, margin);
var TrendingSearchPillContainer = theme_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n    padding: 14px;\n    align-items: center;\n    margin-right: ", "px;\n    white-space: nowrap;\n    cursor: pointer;\n    font-style: italic;\n    border-radius: 20px;\n"], ["\n    background: ", ";\n    display: flex;\n    padding: 14px;\n    align-items: center;\n    margin-right: ", "px;\n    white-space: nowrap;\n    cursor: pointer;\n    font-style: italic;\n    border-radius: 20px;\n"])), js_brand_1.giphyDarkestGrey, margin);
var Avatar = theme_1.default(avatar_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (props) { return theme_1.getSize(props.theme, true); });
var TrendingIcon = theme_1.default(trending_icon_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: 2px;\n"], ["\n    margin-right: 2px;\n"])));
exports.ChannelPill = function (_a) {
    var channel = _a.channel;
    var setActiveChannel = react_1.useContext(context_1.SearchContext).setActiveChannel;
    return (react_1.default.createElement(ChannelPillContainer, { key: channel.id, onClick: function () { return setActiveChannel(channel); } },
        react_1.default.createElement(Avatar, { user: channel.user }),
        react_1.default.createElement("div", null,
            "@",
            channel.user.username),
        channel.user.is_verified && react_1.default.createElement(verified_badge_1.default, { size: 14 })));
};
exports.TrendingSearchPill = function (_a) {
    var trendingSearch = _a.trendingSearch;
    var setSearch = react_1.useContext(context_1.SearchContext).setSearch;
    return (react_1.default.createElement(TrendingSearchPillContainer, { key: trendingSearch, onClick: function () { return setSearch(trendingSearch); } },
        react_1.default.createElement(TrendingIcon, { size: 16 }),
        trendingSearch));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=pills.js.map